/* eslint-disable @typescript-eslint/naming-convention */
import type { SideTwitter } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSTwitter } from '@swf/cms';

import styles from './CMSSideTwitter.scss';

const CMSSideCTA: React.FC<SideTwitter> = ({ account_name }) => (
  <CMSTwitter className={styles.body} account_name={account_name} />
);

export default CMSSideCTA;
